<header class="flex header">
  <h2>Cuadraje de Purchase Orders</h2>
  <p-button icon="pi pi-refresh" [loading]="isLoading() > 0" (onClick)="load()" pTooltip="Reload" />
</header>

<section class="content">
  @if (isLoading() > 0) {
    <loading-overlay [isLoading]="true"></loading-overlay>
  }
  @if (summary; as s) {
    <p-panel>
      <ng-template #header>
        <div class="w-full flex justify-between items-center gap-[1rem]">
          <h4>{{ s.workOrderNumber }}</h4>
          @if (s.overage != null || s.shortage != null) {
            <div class="client-tolerance text-right">
              <div class="client-tolerance-title">Client Tolerance</div>
              @if (s.shortage != null) {
                <div class="client-tolerance-value">Shortage: {{ s.shortage }}%</div>
              }
              @if (s.overage != null) {
                <div class="client-tolerance-value">Overage: {{ s.overage }}%</div>
              }
            </div>
          }
        </div>
      </ng-template>

      <p-panel>
        <ng-template #header>
          <div class="w-full flex justify-between items-center gap-[1rem]">
            <h4>Colors</h4>
            @if (canChangeUnit) {
              <p-selectbutton [ngModel]="unit()" (ngModelChange)="unit.set($event)" [options]="unitOptions" optionLabel="label" optionValue="value" [allowEmpty]="false" />
            }
          </div>
        </ng-template>

        <div class="flex flex-col gap-8">
          @for (color of colors(); track color.colorName) {
            <p-fieldset styleClass="cuadraje-color">
              <ng-template #header>
                <div class="flex items-center gap-[0.5rem]">
                  <span class="color-swatch" [style.background]="color.colorHex"></span>
                  <span class="color-name">{{ color.colorName }}</span>
                </div>
              </ng-template>

              <div class="flex flex-col">
                @for (row of color.fabrics; track row.fabricCode) {
                  <div class="fabric-row grid-12 items-start">
                    <!-- Item, with the Work Order blocks of the bar listed under it -->
                    <div class="span-4">
                      <div class="fabric-type">{{ row.fabricType }}</div>
                      <div class="fabric-code">{{ row.fabricCode }} {{ row.fabricDescription }}</div>

                      <ul class="contribution-list">
                        @for (contribution of contributions(row); track contribution.label) {
                          <li>
                            <span class="legend-marker" [style.background]="contribution.color"></span>
                            <span class="legend-text">
                              {{ contribution.label }}: {{ contribution.value | number: '1.0-2' }} {{ unit() }} ({{ contribution.percentage | number: '1.2-2' }}%)
                            </span>
                          </li>
                        }
                      </ul>
                    </div>

                    <!-- Real vs target, with the client's tolerance drawn over the bar -->
                    <div class="span-5">
                      <div class="flex justify-between items-end gap-[1rem]">
                        <div>
                          <div class="quantity-label">Approved Rolls</div>
                          <div class="quantity-value">
                            {{ approved(row) | number: '1.0-2' }}{{ unit() }}
                            <span class="quantity-percentage">({{ approvedPercentage(row) | number: '1.2-2' }}%)</span>
                          </div>
                        </div>
                        <div class="text-right">
                          <div class="quantity-label">Target</div>
                          <div class="quantity-value">{{ amount(row.target) | number: '1.0-2' }}{{ unit() }}</div>
                        </div>
                      </div>

                      <div class="tolerance-label">Tolerance: {{ amount(row.toleranceMin) | number: '1.0-2' }}-{{ amount(row.toleranceMax) | number: '1.0-2' }}{{ unit() }}</div>

                      <!-- `excessFrom` is the upper tolerance limit, not the target: only what the
                           client will refuse is painted red. -->
                      <csl-tolerance-meter
                        class="fabric-meter"
                        [segments]="segments(row)"
                        [scaleMin]="0"
                        [scaleMax]="scaleMax(row)"
                        [toleranceMin]="amount(row.toleranceMin)"
                        [toleranceMax]="amount(row.toleranceMax)"
                        [target]="amount(row.target)"
                        [excessFrom]="amount(row.toleranceMax)"
                      />

                      <ul class="meter-legend">
                        @for (entry of metrics(row); track entry.label) {
                          <li>
                            <span class="legend-marker" [style.background]="entry.color"></span>
                            <span class="legend-text"> {{ entry.label }}: {{ entry.value | number: '1.0-2' }} {{ unit() }} ({{ entry.percentage | number: '1.2-2' }}%) </span>
                          </li>
                        }

                        <!-- On Hold is not part of the balance, so it is ruled off from the rest -->
                        @if (onHoldMetric(row); as onHoldEntry) {
                          <li class="legend-separated">
                            <span class="legend-marker" [style.background]="onHoldEntry.color"></span>
                            <span class="legend-text">
                              {{ onHoldEntry.label }}: {{ onHoldEntry.value | number: '1.0-2' }} {{ unit() }} ({{ onHoldEntry.percentage | number: '1.2-2' }}%)
                            </span>
                          </li>
                        }
                      </ul>
                    </div>

                    <!-- Where it lands against the client's tolerance -->
                    <div class="span-3 flex justify-end">
                      <p-tag [value]="statusLabel(row)" [severity]="statusSeverity(row)" />
                    </div>
                  </div>
                }
              </div>
            </p-fieldset>
          }
        </div>
      </p-panel>
    </p-panel>
  }
</section>

<footer>
  <p-button class="w-full" label="Close" variant="outlined" (click)="onClose()" />
</footer>
